import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import YoybuySpreadsheetGuide from "@/pages/yoybuy-spreadsheet-guide/page";
import YoybuyKakobuySravnenie from "@/pages/articles/yoybuy-kakobuy-sravnenie/page";
import BezopasnostYoybuy from "@/pages/articles/bezopasnost-yoybuy/page";
import DostavkaYoybuy from "@/pages/articles/dostavka-yoybuy/page";
import QCGidYoybuy from "@/pages/articles/qc-gid-yoybuy/page";
import LuchshieNahodkiYoybuy from "@/pages/articles/luchshie-nahodki-yoybuy/page";
import KuponyYoybuy from "@/pages/articles/kupony-yoybuy/page";
import YoybuyDlyaNachinayushih from "@/pages/articles/yoybuy-dlya-nachinayushih/page";
import BrendovyeTablitsyYoybuy from "@/pages/articles/brendovye-tablitsy-yoybuy/page";
import YoybuyVsSuperbuy from "@/pages/articles/yoybuy-vs-superbuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/yoybuy-spreadsheet-guide",
    element: <YoybuySpreadsheetGuide />,
  },
  {
    path: "/yoybuy-kakobuy-sravnenie",
    element: <YoybuyKakobuySravnenie />,
  },
  {
    path: "/bezopasnost-yoybuy",
    element: <BezopasnostYoybuy />,
  },
  {
    path: "/dostavka-yoybuy",
    element: <DostavkaYoybuy />,
  },
  {
    path: "/qc-gid-yoybuy",
    element: <QCGidYoybuy />,
  },
  {
    path: "/luchshie-nahodki-yoybuy",
    element: <LuchshieNahodkiYoybuy />,
  },
  {
    path: "/kupony-yoybuy",
    element: <KuponyYoybuy />,
  },
  {
    path: "/yoybuy-dlya-nachinayushih",
    element: <YoybuyDlyaNachinayushih />,
  },
  {
    path: "/brendovye-tablitsy-yoybuy",
    element: <BrendovyeTablitsyYoybuy />,
  },
  {
    path: "/yoybuy-vs-superbuy",
    element: <YoybuyVsSuperbuy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;